import gql from 'graphql-tag';

import { fragmentBettingOpportunities, fragmentBettingOpportunitiesV2 } from './fragments';

export const BETTING_OPPORTUNITIES_QUERY = gql`
  query bettingOpportunities(
    $channel: String!
    $legs: [LegInput!]!
    $combinationSelections: [CombinationSelection]!
    $walletType: String
    $selectedBetsOnly: Boolean
    $requestedLine: Float
    $requestedPotentialReturns: Int
    $parlayCardEditionId: String
    $playerCardProviderId: String
  ) {
    bettingOpportunities(
      where: {
        channel: $channel
        legs: $legs
        combinationSelections: $combinationSelections
        walletType: $walletType
        selectedBetsOnly: $selectedBetsOnly
        requestedLine: $requestedLine
        requestedPotentialReturns: $requestedPotentialReturns
        parlayCardEditionId: $parlayCardEditionId
        playerCardProviderId: $playerCardProviderId
      }
    ) {
      ...opportunities
    }
  }

  ${fragmentBettingOpportunities}
`;

export const BETTING_OPPORTUNITIES_QUERY_V2 = gql`
  query bettingOpportunitiesV2(
    $channel: String!
    $legs: [LegInputV2!]!
    $combinationSelections: [CombinationSelectionV2]!
    $walletType: String
    $selectedBetsOnly: Boolean
    $requestedLine: Float
    $requestedPotentialReturns: Int
    $parlayCardEditionId: String
    $playerCardProviderId: String
  ) {
    bettingOpportunitiesV2(
      where: {
        channel: $channel
        legs: $legs
        combinationSelections: $combinationSelections
        walletType: $walletType
        selectedBetsOnly: $selectedBetsOnly
        requestedLine: $requestedLine
        requestedPotentialReturns: $requestedPotentialReturns
        parlayCardEditionId: $parlayCardEditionId
        playerCardProviderId: $playerCardProviderId
      }
    ) {
      ...opportunitiesV2
    }
  }

  ${fragmentBettingOpportunitiesV2}
`;
